import React, { FC, useState, useEffect } from "react";
import { Button } from "../../components/Modal";
import InputField from "../../components/Modal/InputField";
import styles from "../../styles/Template.module.css";
import {
  FormData,
  Category,
  IEditTemplateRes,
} from "../../hooks/rtmTemplate/index.type";
import { FormErrors } from "./AddTemplateModal";

interface CategorySectionProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  setEditCategory: React.Dispatch<React.SetStateAction<Category>>;
  next: boolean;
  formErrors: FormErrors;
  setFormErrors: React.Dispatch<React.SetStateAction<FormErrors>>;
  handleNextClick: () => void;
  editCategory: Category;
  isEditing: boolean;
 handleToggleEditState: (state: boolean) => void;
 templateId?:string
}

const CategorySection: FC<CategorySectionProps> = ({
  isEditing,
  setEditCategory,
  formData,
  setFormData,
  formErrors,
  setFormErrors,
  handleNextClick,
  editCategory,

}) => {
  const [categoryInput, setCategoryInput] = useState("");
  const groupBy = formData.questionGroupedByCategory as "yes" | "no";

  useEffect(() => {
    if (groupBy) {
      setFormErrors((prev) => ({ ...prev, groupedByCategory: "" }));
    }
  }, [groupBy, setFormErrors]);




  useEffect(() => {
    if (editCategory && editCategory.name) {
      setCategoryInput(editCategory.name);
    } else {
      setCategoryInput("");
    }
  }, [editCategory]);

  const handleAddCategory = () => {
    const trimmed = categoryInput.trim();
    if (!trimmed) {
      setFormErrors((prev) => ({
        ...prev,
        categories: "Category cannot be empty",
      }));
      return;
    }

    setFormData((prev) => {
      let updatedCategories;

      if (editCategory && editCategory.key) {
        // Edit existing category name only, keep sequence as is
        updatedCategories = prev.categories.map((cat) =>
          cat.key === editCategory.key ? { ...cat, name: trimmed } : cat
        );
      } else {
        // Add new category
        const newCat = {
          key: Date.now().toString(),
          name: trimmed,
          sequence: (prev.categories?.length || 0) + 1,
        };
        updatedCategories = [...(prev.categories || []), newCat];

        // Reassign sequence numbers for new category only
        updatedCategories = updatedCategories.map((cat, index) => ({
          ...cat,
          sequence: index + 1,
        }));
      }

      return { ...prev, categories: updatedCategories };
    });

    setCategoryInput("");
    setFormErrors((prev) => ({ ...prev, categories: "" }));
    setEditCategory({ key: "", name: "" });
  };

  const handleGroupChange = (value: "yes" | "no") => {
    setFormData((prev) => ({
      ...prev,
      questionGroupedByCategory: value,
      categories: value === "yes" ? prev.categories : [],
    }));

    setFormErrors((prev) => ({
      ...prev,
      groupedByCategory: "",
      categories: "",
    }));
  };


  return (
    <div className={styles.sub_section_5}>
      <div className={styles.categories}>
        <span>Are the questions grouped by categories?</span>
        <div
          className={styles.category_btn_container}
          style={
            isEditing
              ? {
                  pointerEvents: "none",
                  opacity: 0.6,
                }
              : {}
          }
        >
          <div className={styles.category_btn}>
            <Button
              span={false}
              label="Yes"
              customClass={
                formData.questionGroupedByCategory === "yes"
                  ? styles.button_active
                  : styles.button
              }
              onClick={() => handleGroupChange("yes")}
            />
            <Button
              span={false}
              label="No"
              customClass={
                formData.questionGroupedByCategory === "no"
                  ? styles.button_active
                  : styles.button
              }
              onClick={() => handleGroupChange("no")}
            />
          </div>
          {formErrors.groupedByCategory && (
            <p className={styles.radio_btn_error}>
              {formErrors.groupedByCategory}
            </p>
          )}
        </div>
      </div>

      {groupBy === "yes" && (
        <div className={styles.category_input}>
          <span>Category Name:</span>
          <div className={styles.category_1}>
            <div className={styles.category_2}>
              <InputField
                value={categoryInput}
                onChange={(e) => {
                  const value = e.target.value;
                  setCategoryInput(value);
                }}
                inputCustomStyle={{ width: "18.5rem" }}
                containerClass={styles.category_input_field}
                errorClass={styles.error}
                errorMessage={formErrors.categories}
              />
            </div>

            <Button
              span={false}
              label={editCategory.key ? "Update" : "Add More"}
              icon={editCategory.key ? "icon-edit-2" : "icon-add"}
              customClass={styles.addMore}
              iconStyle={{ width: "2rem", height: "1.5rem" }}
              onClick={handleAddCategory}
            />
          </div>
        </div>
      )}

      <div className={styles.next_btn_box}>
        <Button
          span={false}
          label="Next"
          customClass={styles.next_btn}
          onClick={handleNextClick}
          icon="icon-chevron-right"
          iconStyle={{ height: "2rem", width: "2rem" }}
        />
      </div>
    </div>
  );
};

export default CategorySection;
